import { apiPut } from "../ApiMethod";
import { setFirmwareData } from "../../mappers";

export const updateFirmware = async (data, id) => {
  const response = await apiPut("_firmware", id, data);
  return { ...response, data: setFirmwareData(response.data) };
};
